import { useCallback, useState } from "react";
import { createTimer } from "@flights/web-api-utils-universal";
import useClientMetrics from "./useClientMetrics.js";
export default function useMeasureSearchToFlightDetails() {
    const { trackClientMetric } = useClientMetrics();
    const [isMeasured, setIsMeasured] = useState(false);
    const [timer, setTimer] = useState(null);
    const onFetchedResults = useCallback(() => {
        const timer = createTimer();
        setTimer(() => timer);
    }, [setTimer]);
    const onSelectFlight = useCallback(() => {
        if (!timer || isMeasured) {
            return;
        }
        const time = timer();
        trackClientMetric("search_time_to_first_click_flight_details", time);
        setIsMeasured(true);
    }, [timer, isMeasured, trackClientMetric]);
    return { onFetchedResults, onSelectFlight };
}
